import { useNavigate } from "react-router";
import { useDocumentPath } from "@/services/backend/documents/components/use-document-path";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { useEffect } from "react";
import { FulfillmentState } from "@/services/backend/relationships/types/fulfillment";
import { WorkOrder } from "@/services/backend/htz/work-order/types/work-order";

export function useWorkOrderStateGuard(
  workOrder: WorkOrder | undefined,
  ...state: FulfillmentState[]
) {
  const navigate = useNavigate();
  const { path } = useDocumentPath({
    documentId: workOrder?.id || "",
    documentKind: workOrder?.documentKind || "",
    serviceKind: GSMServiceKind.HTZ || "",
    processId: workOrder?.processId || "",
  });

  useEffect(() => {
    if (!workOrder) return;
    if (!path) return;

    if (!state.includes(workOrder.workOrderState)) {
      navigate(path);
    }
  }, [navigate, path, state, workOrder]);
}
